<template>
  <div
    class="overlay"
    :class="{'visible': visible}"
    @click="triggerMassClose()"></div>
</template>

<script>
import { EventBus } from '@/event-bus.js'

export default {
  props: {
    forced: Boolean
  },
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    EventBus.$on('overlayToggle', this.overlayToggle)
    EventBus.$on('overlayShow', this.overlayShow)
    EventBus.$on('overlayHide', this.overlayHide)
    EventBus.$on('overlayCloseForPopup', this.overlayCheckPopupClose)
  },
  destroyed () {
    EventBus.$off('overlayToggle', this.overlayToggle)
    EventBus.$off('overlayShow', this.overlayShow)
    EventBus.$off('overlayHide', this.overlayHide)
    EventBus.$off('overlayCloseForPopup', this.overlayCheckPopupClose)
  },
  methods: {
    overlayToggle (value) {
      this.visible = value
    },
    overlayShow (value) {
      this.visible = true
    },
    overlayHide (value) {
      this.visible = false
    },
    overlayCheckPopupClose () {
      if (this.$parent.$el.classList.contains('modal')) {
        this.visible = false
      } else {
        // if no modals are present then close
        const allDialogs = document.querySelectorAll('.modal')
        if (allDialogs.length === 0) {
          this.visible = false
        }
      }
    },
    triggerMassClose () {
      // it's forced when the invalid license dialog is visible
      if (this.forced) { return false }

      const allDropdowns = document.querySelectorAll('.close-by-overlay')
      for (let i = 0; i < allDropdowns.length; ++i) {
        allDropdowns[i].checked = false
      }

      // check that modals are still open
      if (this.$parent.$el.classList.contains('modal')) {
        this.visible = false
      }

      EventBus.$emit('overlayCloseForPopup')

      // if no modals are present then close
      const allDialogs = document.querySelectorAll('.modal')
      if (allDialogs.length === 0) {
        this.visible = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .overlay {
    display: none;
    position: absolute;
    @include cover;
    background: transparent;
    z-index: 1;

    height: 100%;

    &.visible {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/basic/DropOverlay.vue